import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    success: 'Success',
    close: 'Close',
    stakedValue: 'You successfully unstaked {value} {stakedToken}.',
    justSentValue: '{value} {nativeToken} sent to your wallet.',
  },
};
